module.exports = __webpack_public_path__ + "img/weronika-ratkowska@1x.5f279c24.jpg";